import { ParsedUrlQuery } from 'querystring';

export const filterActivated = (queryParams: ParsedUrlQuery): boolean => {
  return [
    'pref_color',
    'pref_fit',
    'pref_maxPrice',
    'pref_minPrice',
    'pref_size',
    'pref_style',
    'sort',
  ].some(filter => Object.keys(queryParams).includes(filter));
};
